export default __webpack_public_path__ + "static/media/phone.2c23ec01.svg";